import { HttpErrorResponse } from '@angular/common/http';
import { computed, inject, Signal } from '@angular/core';
import { AssetDto, AssetsControllerService } from '@api/client';
import { tapResponse } from '@ngrx/operators';
import {
  patchState,
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';

export const useAssets = () =>
  signalStoreFeature(
    {
      props: {
        _activeAccountId: type<Signal<number | undefined>>(),
      },
    },
    withState({
      assets: new Array<AssetDto>(),
    }),
    withProps(() => ({
      _assetsService: inject(AssetsControllerService),
    })),
    withComputed(store => {
      const fiatAssets = computed(() => store.assets().filter(asset => asset.fiat));

      const cryptoAssets = computed(() => store.assets().filter(asset => !asset.fiat));

      const assetScaleMap = computed(
        () => new Map(store.assets().map(asset => [asset.code, asset.scale])),
      );

      return { fiatAssets, cryptoAssets, assetScaleMap };
    }),
    withMethods(store => {
      const loadAssets = rxMethod<void>(
        pipe(
          switchMap(() =>
            store._assetsService.getAssets(store._activeAccountId()).pipe(
              tapResponse({
                next: (assets: AssetDto[]) => patchState(store, { assets }),
                error: (_error: HttpErrorResponse) => undefined,
              }),
            ),
          ),
        ),
      );

      return { loadAssets };
    }),
  );
